import styled from "styled-components";
import {colors} from "../../../themes/colors";
import {sizes} from "../../../themes/sizes";
import {fontSize} from "../../../themes/css";

export const ButtonWrapper = styled.div`
  font-style: normal;
  font-weight: 600;
  ${fontSize(17)}
  line-height: 120%;
  text-align: center;
  color: ${colors.general.white};
  padding: 15px 34px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: ${props => props.variant === 'green' ? colors.background.salem : colors.general.persianBlue};
  :hover {
    background: ${props => props.variant === 'green' ? colors.general.malachite : colors.general.blueRibbon};
  }
  border-radius: 1000px;
  white-space: pre-wrap;
  @media only screen and ${sizes.max991} {
    border-radius: 200vw;
    padding: 3vw 6.8vw;
  }
`;

export const ButtonCenterWrapper = styled.div`
  background: ${colors.general.white};
  border: 2px solid ${colors.general.white};
  border-radius: 300px;
  padding: 0;
  @media only screen and ${sizes.max991} {
    border-radius: 60vw;
  }
`;

export const ButtonOuterWrapper = styled.button`
  white-space: pre-wrap;
  width: fit-content;
  align-self: center;
  background: ${colors.general.white};
  border: 4px solid ${props => props.variant === 'green' ? colors.background.salem : colors.general.persianBlue};
  border-radius: 300px;
  padding: 0;
  cursor: ${props => props.disabled ? 'initial' : 'pointer'};
  user-select: none;
  :hover {
    ${props => props.disabled ? '' : `border-color: ${props.variant === 'green' ? colors.general.malachite : colors.general.blueRibbon};`}
  }
  ${props => props.disabled && 'opacity: 0.4;'}
  @media only screen and ${sizes.max991} {
    border-radius: 60vw;
  }
`;
